const extractEvents = require('./getEvents/extractEvents');
const extractExternalEvents = require('./getEvents/extractExternalEvents');
const extractCustomsEvent = require('./getEvents/extractCustomsEvent');
const extractStartStopEvents = require('./getEvents/extractStartStopEvents');
const interweaveOtherEvents = require('./getEvents/interweaveOtherEvents');
const negotiateSetLastConfirmed = require('./getEvents/negotiateSetLastConfirmed');
const tryRemoveDuplicateEvents = require('./getEvents/tryRemoveDuplicateEvents');
const { getTranslationDictionary } = require('core');
const flatMap = require('lodash.flatmap');

module.exports = function getEvents(dto) {
	var externalEvents = flatMap(dto.ExternalEvent, extractExternalEvents.bind(null, dto));
	var tripEvents = flatMap(dto.Legs, extractEvents);
	var newStyleEvents = false;
	externalEvents.forEach(event => {
		if(event.location) {
			newStyleEvents = true;
			return;
		}
	});

	if(dto.PreferTripEvents) {
		//Filter estimated tripEvents
		var events = tripEvents.filter(tE => tE.isActual);
		if(externalEvents.length > 0)
			externalEvents = externalEvents.filter(ev => !ev.isInternal);

		var customsEvent = extractCustomsEvent(dto.CustomsEvent);
		if(externalEvents && externalEvents.length > 0)
			interweaveOtherEvents(events, externalEvents);
		if(customsEvent.length > 0)
			interweaveOtherEvents(events, customsEvent)
		negotiateSetLastConfirmed(events);

		if(events.length === 0) {
			var translationDictionary = getTranslationDictionary();
			var placeActionText = translationDictionary['noEvents'];
			events.push({
				placeAction: placeActionText,
				place: '',
				isActual: false
			})
		}
		return events;
	}

	//Filter estimated tripEvents
	tripEvents = tripEvents.filter(tE => tE.isActual);

	var events = tryRemoveDuplicateEvents(externalEvents, tripEvents);
	if(!newStyleEvents)
		events = extractStartStopEvents(dto, events);

	var customsEvent = extractCustomsEvent(dto.CustomsEvent);
	var events = events.concat(customsEvent);
	var result = [];
	interweaveOtherEvents(result, events);
	negotiateSetLastConfirmed(result);

	return result;
};
